import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';
import { bindActionCreators } from 'redux';
import { SitecoreImageField } from 'components/sitecore-fields';
import {
    handleCheckIsMasterCardMember
} from '../helpers/toch-helpers';
import * as userAccountActions from '../../../sso/store/actions/user-account-actions';
import { isEmpty } from '../../../sso/components/utils/obj-utils';
import MastercardRegistration from '../mastercard-registration/MasterCardRegistration';
import TOCHModal from '../helpers/TOCHModal';
import Oauth from '../../../sso/components/oauth';
import { CookieNames } from '../../../../general/js/utils/cookies';
import { safeParseJSON } from '../../../../general/js/general-helpers';
import eventBus from '../../../../general/js/event-bus';
import { BusEvents } from '../../../../general/js/event-bus-constants';

class HeaderHero extends Component {
    constructor(...args) {
        super(...args);

        this.state = {
            cookieValue: '',
            masterCardData: null,
            isModalOpen: false,
            options: null
        };

        this.getUserData = this.getUserData.bind(this);
        this.getUserInitials = this.getUserInitials.bind(this);
        this.checkStringForEmpty = this.checkStringForEmpty.bind(this);
        this.getUserDetails = this.getUserDetails.bind(this);
        this.loadMasterCardUpgradeFormData = this.loadMasterCardUpgradeFormData.bind(this);
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);

        this.init();
    }

    init() {
        eventBus.addListener(BusEvents.USER_MEMBERSHIP_UPDATE, this.getUserData);
    }

    onDestroy() {
        eventBus.removeListener(BusEvents.USER_MEMBERSHIP_UPDATE, this.getUserData);
    }

    componentDidMount() {
        this.getUserData();
        this.loadMasterCardUpgradeFormData();
    }

    getUserData(event) {
        const { actions } = this.props;
        const { getUserAccountDataCallBackURL } = this.props.data;
        const tochUserDataCookie = Cookies.get(CookieNames.TOCH_USER_DATA);

        if ((event && event.bypassCache) || isEmpty(tochUserDataCookie)) actions.getUserAccountData(getUserAccountDataCallBackURL);
        else this.setState({ cookieValue: tochUserDataCookie });
    }

    getUserInitials(userAccountData) {
        if (userAccountData !== undefined && userAccountData.firstName !== undefined && userAccountData.lastName !== undefined) {
            userAccountData.firstName = userAccountData.firstName.trim();
            userAccountData.lastName = userAccountData.lastName.trim();

            const firstNameChar = this.checkStringForEmpty(userAccountData.firstName) ? '' : userAccountData.firstName.charAt(0);
            const lastNameChar = this.checkStringForEmpty(userAccountData.lastName) ? '' : userAccountData.lastName.charAt(0);

            return firstNameChar + lastNameChar;
        }

        return 'TT';
    }

    handleOnCloseModal = (value) => {
        this.setState({ isModalOpen: value });
    }

    checkStringForEmpty(name) {
        if (name === '') return true;

        return false;
    }

    getUserDetails() {
        const { cookieValue } = this.state;
        const { userAccountData, isUserNotSignedIn, isUserAccountDataLoadedSuccessful } = this.props;
        const cookie = safeParseJSON(cookieValue);
        const userData = isEmpty(cookieValue) ? userAccountData : cookie;

        const dataLoadedSuccessful = (!isUserNotSignedIn && isUserAccountDataLoadedSuccessful && !isEmpty(userAccountData)) || (!isEmpty(cookieValue));

        const userInitials = dataLoadedSuccessful && userData.isOneClub !== null ? this.getUserInitials(userData) : 'TT';

        const createdYear = dataLoadedSuccessful && userData.isOneClub !== null ?
            new Date(userData.createdDate).getFullYear() :
            new Date(Date.now()).getFullYear();

        const becameMasterCard = dataLoadedSuccessful && userData.isOneClub !== null ?
            new Date(userData.becameMasterCard).getFullYear() :
            new Date(Date.now()).getFullYear();

        const firstName = dataLoadedSuccessful && userData.isOneClub !== null ? userData.firstName : 'Test';

        const userDetails = {
            dataLoadedSuccessful,
            userInitials,
            createdYear,
            firstName,
            becameMasterCard
        };

        return userDetails;
    }

    loadMasterCardUpgradeFormData() {
        const { mastercardUpgradeEndpoint } = this.props.data;

        axios.post(mastercardUpgradeEndpoint).then((response) => {
            this.setState({ masterCardData: response.data });
        }).catch((error) => {
            this.setState({ formHasErrors: true });
            console.error(error);
        });
    }

    render() {
        const userDetails = this.getUserDetails();

        const {
            backgroundImage,
            helloMessage,
            welcomeMessage,
            headerLogoImage,
            membershipStatusMessage,
            membershipUpgradedStatusMessage,
            upgradeText,
            topButtonText,
            isInEditMode
        } = this.props.data;

        const { isModalOpen, options } = this.state;

        const isMasterCardMember = handleCheckIsMasterCardMember(CookieNames.TOCH_USER_MEMBERSHIPS);

        const displayMessage = isMasterCardMember ? membershipUpgradedStatusMessage : membershipStatusMessage;

        const displayYear = isMasterCardMember ? userDetails.becameMasterCard : userDetails.createdYear;

        const showData = isInEditMode || userDetails.dataLoadedSuccessful;

        return (
            showData &&
            <div>
                {isModalOpen && options != null && !isMasterCardMember ?
                    <div>
                        <div className="overlay is-visible" id="overlay" />
                        <TOCHModal
                            handleOnClose={this.handleOnCloseModal}>
                            <MastercardRegistration
                                options={options}
                            ></MastercardRegistration>
                        </TOCHModal>
                    </div> :
                    null}
                <div>
                    <div className="header-hero__media">
                        <div className="header-hero__media--backgroundImage">
                            <SitecoreImageField img={backgroundImage} className='' />
                        </div>
                    </div>
                    <div className="container">
                        <div className="header-hero__inner">
                            <div className="header-hero__wellcomeMsg">
                                <span className="header-hero__wellcomeMsg--initials">
                                    {userDetails.userInitials}
                                </span>

                                <div className="header-hero__wellcomeMsg--userDetails">
                                    <p className="header-hero__wellcomeMsg--title">
                                        {helloMessage + ' ' + userDetails.firstName}
                                    </p>
                                    <p className="header-hero__wellcomeMsg--description">
                                        {welcomeMessage}
                                    </p>
                                </div>
                            </div>
                            <div className="header-hero__logos">
                                <div className="header-hero__logos--oneClub">
                                    <SitecoreImageField img={headerLogoImage} />
                                </div>
                            </div>
                            <div className="header-hero__upgrade">
                                {
                                    !isMasterCardMember &&
                                    <div>
                                        {
                                            !isEmpty(topButtonText) &&
                                            <p className="header-hero__upgrade--description" dangerouslySetInnerHTML={{ __html: topButtonText }}></p>
                                        }
                                        <button type="button" className="header-hero__upgrade--link" onClick={() => Oauth.mastercardUpgrade()}>
                                            <div dangerouslySetInnerHTML={{ __html: upgradeText }}></div>
                                        </button>
                                    </div>
                                }
                                <p className="header-hero__upgrade--membershipStatus">
                                    { displayMessage}
                                    <span className="header-hero__upgrade--createdYear">{displayYear}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div >
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isUserNotSignedIn: state.userAccount.isUserNotSignedIn,
        isUserAccountDataLoadedSuccessful: state.userAccount.isUserAccountDataLoadedSuccessful,
        userAccountData: state.userAccount.userAccountData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            getUserAccountData: bindActionCreators(userAccountActions.getUserAccountData, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeaderHero);
